import { useContext } from "react";
import { useFormContext, UseFormRegister } from "react-hook-form";
import { arrayHasExactlyOneItem } from "common/utils/arrays";
import { AuthContext } from "../../../../Authorization/AuthContext";
import { Label } from "../../../../Inputs";
import { Checkbox } from "../../../../Inputs/react-hook-form";
import { UpdateOrCreatePropertyAttributesFormStructure } from "./updateOrCreateSectionAttributeModal";

export const DisplaySettings = ({
  isGreatestInclusionCustomMapAttribute,
  isBFEAttribute,
}: {
  isGreatestInclusionCustomMapAttribute: boolean;
  isBFEAttribute: boolean;
}) => {
  const { account } = useContext(AuthContext);
  const { control } =
    useFormContext<UpdateOrCreatePropertyAttributesFormStructure>();

  const inputs: {
    id: Parameters<
      UseFormRegister<UpdateOrCreatePropertyAttributesFormStructure>
    >["0"];
    labelId: string;
    text: string;
  }[] = [];

  if (account?.publicPortal.enabled) {
    inputs.push({
      id: "isPublic",
      labelId: "displaySettingLabel",
      text: "Display on public website",
    });
  }

  if (isBFEAttribute) {
    inputs.push({
      id: "displayConfig.showApproximateBfeTool",
      labelId: "showApproximateBfeToolLabel",
      text: "Enable approximate BFE calculation",
    });
  }

  if (isGreatestInclusionCustomMapAttribute) {
    inputs.push({
      id: "displayValueAsLink",
      labelId: "displayValueAsLinkLabel",
      text: "Display value as link",
    });
  }

  if (!inputs.length) {
    return null;
  }

  const label =
    arrayHasExactlyOneItem(inputs) ? "Display setting" : "Display settings";

  return (
    <div>
      <Label text={label} required />
      {inputs.map(input => {
        const { id, labelId, text } = input;
        return (
          <Checkbox
            key={id}
            name={id}
            control={control}
            aria-labelledby={labelId}
            label={text}
          />
        );
      })}
    </div>
  );
};
